export default "__VITE_ASSET__ChEhAb9___"